import { Country } from './countries'

const posPanelConfigurations = {
  tips: 1,
  discounts: 2,
  comments: 3,
  concepts: 4,
  paymentCash: 101,
  paymentCredit: 102,
  paymentCard: 103,
  paymentTransfer: 104,
  payPreBill: 201,
  payBill: 202,
  payOrder: 203, // INVOICE WITHOUT IVA
  payReceipt: 204,
  payExcludedSubject: 607, // EXCLUDED SUBJECT
  payFiscalCredit: 608, // FISCAL CREDIT
  payFiscalInvoice: 609, // INVOICE
  payExportation: 610, // EXPORTATION INVOICE
  tabOrders: 301,
  tabSplit: 302,
  actionTransfer: 401,
  actionBarcode: 402,
  actionClear: 403,
  actionPaymentMultiple: 404,
  actionAgileOrderPrint: 405,
  actionCreateClient: 406,
  actionEditClient: 407,
  actionAddTickets: 408,
  actionSubTotalTicket: 409,
  actionOpenCashBox: 410,
  timer: 501,
  identification1: 601,
  identification2: 602,
  identification3: 603,
  identification4: 604,
  identification5: 605,
  identification6: 606,
  identification7: 617,
}

const posConfigurationGroup = {
  GENERAL: 1,
  CLIENT: 2,
  PAYMENTS: 3,
  CLOSE: 4,
  INVOICE: 5,
  TABS: 6,
  ACTIONS: 7,
}

const posPanelConfigurationFields: IDictionary<IPOSPanelConfigurationField> = {
  [posPanelConfigurations.tips]: {
    type: posPanelConfigurations.tips,
    name: 'Agregar propina',
    groupBy: posConfigurationGroup.GENERAL,
  },
  [posPanelConfigurations.discounts]: {
    type: posPanelConfigurations.discounts,
    name: 'Agregar descuentos',
    groupBy: posConfigurationGroup.GENERAL,
  },
  [posPanelConfigurations.comments]: {
    type: posPanelConfigurations.comments,
    name: 'Agregar comentarios',
    groupBy: posConfigurationGroup.GENERAL,
  },
  [posPanelConfigurations.concepts]: {
    type: posPanelConfigurations.concepts,
    name: 'Agregar conceptos de facturación',
    groupBy: posConfigurationGroup.GENERAL,
  },
  [posPanelConfigurations.paymentCash]: {
    type: posPanelConfigurations.paymentCash,
    name: 'Pago en efectivo',
    groupBy: posConfigurationGroup.PAYMENTS,
  },
  [posPanelConfigurations.paymentCredit]: {
    type: posPanelConfigurations.paymentCredit,
    name: 'Pago con crédito',
    groupBy: posConfigurationGroup.PAYMENTS,
  },
  [posPanelConfigurations.paymentCard]: {
    type: posPanelConfigurations.paymentCard,
    name: 'Pago con tarjeta',
    groupBy: posConfigurationGroup.PAYMENTS,
  },
  [posPanelConfigurations.paymentTransfer]: {
    type: posPanelConfigurations.paymentTransfer,
    name: 'Transferencia bancaria',
    groupBy: posConfigurationGroup.PAYMENTS,
  },
  [posPanelConfigurations.payPreBill]: {
    type: posPanelConfigurations.payPreBill,
    name: 'Pre cuenta',
    groupBy: posConfigurationGroup.CLOSE,
  },
  [posPanelConfigurations.payBill]: {
    type: posPanelConfigurations.payBill,
    name: 'Facturar',
    groupBy: posConfigurationGroup.CLOSE,
  },
  [posPanelConfigurations.payOrder]: {
    type: posPanelConfigurations.payOrder,
    name: 'Orden',
    groupBy: posConfigurationGroup.CLOSE,
  },
  [posPanelConfigurations.payReceipt]: {
    type: posPanelConfigurations.payReceipt,
    name: 'Recibo',
    groupBy: posConfigurationGroup.CLOSE,
  },
  [posPanelConfigurations.payExcludedSubject]: {
    type: posPanelConfigurations.payExcludedSubject,
    name: 'Sujeto excluido',
    groupBy: posConfigurationGroup.INVOICE,
    countries: [Country.SV],
  },
  [posPanelConfigurations.payFiscalCredit]: {
    type: posPanelConfigurations.payFiscalCredit,
    name: 'Crédito Fiscal',
    groupBy: posConfigurationGroup.INVOICE,
    countries: [Country.SV],
  },
  [posPanelConfigurations.payFiscalInvoice]: {
    type: posPanelConfigurations.payFiscalInvoice,
    name: 'Factura',
    groupBy: posConfigurationGroup.INVOICE,
    countries: [Country.SV],
  },
  [posPanelConfigurations.payExportation]: {
    type: posPanelConfigurations.payExportation,
    name: 'Factura de exportación',
    groupBy: posConfigurationGroup.INVOICE,
    countries: [Country.SV],
  },
  [posPanelConfigurations.tabOrders]: {
    type: posPanelConfigurations.tabOrders,
    name: 'Comandas',
    groupBy: posConfigurationGroup.TABS,
  },
  [posPanelConfigurations.tabSplit]: {
    type: posPanelConfigurations.tabSplit,
    name: 'Cuentas separadas',
    groupBy: posConfigurationGroup.TABS,
  },
  [posPanelConfigurations.actionTransfer]: {
    type: posPanelConfigurations.actionTransfer,
    name: 'Transferir terminal',
    groupBy: posConfigurationGroup.ACTIONS,
  },
  [posPanelConfigurations.actionBarcode]: {
    type: posPanelConfigurations.actionBarcode,
    name: 'Escanear código de barras',
    groupBy: posConfigurationGroup.ACTIONS,
  },
  [posPanelConfigurations.actionClear]: {
    type: posPanelConfigurations.actionClear,
    name: 'Limpiar terminal',
    groupBy: posConfigurationGroup.ACTIONS,
  },
  [posPanelConfigurations.actionPaymentMultiple]: {
    type: posPanelConfigurations.actionPaymentMultiple,
    name: 'Pagos mixtos',
    groupBy: posConfigurationGroup.ACTIONS,
  },
  [posPanelConfigurations.actionAgileOrderPrint]: {
    type: posPanelConfigurations.actionAgileOrderPrint,
    name: 'imprimir comandas',
    groupBy: posConfigurationGroup.ACTIONS,
    posSteps: [4],
  },
  [posPanelConfigurations.actionCreateClient]: {
    type: posPanelConfigurations.actionCreateClient,
    name: 'APP-KOLO: Crear cliente',
    groupBy: posConfigurationGroup.ACTIONS,
  },
  [posPanelConfigurations.actionEditClient]: {
    type: posPanelConfigurations.actionEditClient,
    name: 'APP-KOLO: Editar cliente',
    groupBy: posConfigurationGroup.ACTIONS,
  },
  [posPanelConfigurations.timer]: {
    type: posPanelConfigurations.timer,
    name: 'Temporizador',
    groupBy: posConfigurationGroup.GENERAL,
  },
  [posPanelConfigurations.identification1]: {
    type: posPanelConfigurations.identification1,
    name: 'NIT',
    groupBy: posConfigurationGroup.CLIENT,
    countries: [Country.GT],
  },
  [posPanelConfigurations.identification2]: {
    type: posPanelConfigurations.identification2,
    name: 'DPI',
    groupBy: posConfigurationGroup.CLIENT,
    countries: [Country.GT],
  },
  [posPanelConfigurations.identification3]: {
    type: posPanelConfigurations.identification3,
    name: 'NIT',
    groupBy: posConfigurationGroup.CLIENT,
    countries: [Country.SV],
  },
  [posPanelConfigurations.identification4]: {
    type: posPanelConfigurations.identification4,
    name: 'NRC',
    groupBy: posConfigurationGroup.CLIENT,
    countries: [Country.SV],
  },
  [posPanelConfigurations.identification5]: {
    type: posPanelConfigurations.identification5,
    name: 'DUI',
    groupBy: posConfigurationGroup.CLIENT,
    countries: [Country.SV],
  },
  [posPanelConfigurations.identification7]: {
    type: posPanelConfigurations.identification7,
    name: 'RTN',
    groupBy: posConfigurationGroup.CLIENT,
    countries: [Country.HN],
  },
  [posPanelConfigurations.identification6]: {
    type: posPanelConfigurations.identification6,
    name: 'ID Extranjero',
    groupBy: posConfigurationGroup.CLIENT,
  },
  [posPanelConfigurations.actionAddTickets]: {
    type: posPanelConfigurations.actionAddTickets,
    name: 'APP-KOLO: Agregar tickets',
    groupBy: posConfigurationGroup.ACTIONS,
  },
  [posPanelConfigurations.actionSubTotalTicket]: {
    type: posPanelConfigurations.actionSubTotalTicket,
    name: 'APP-KOLO: Subtotal por ticket',
    groupBy: posConfigurationGroup.ACTIONS,
  },
  [posPanelConfigurations.actionOpenCashBox]: {
    type: posPanelConfigurations.actionOpenCashBox,
    name: 'APP-KOLO: Abrir caja de efectivo manualmente',
    groupBy: posConfigurationGroup.ACTIONS,
  },
}

const posConfigurationGroupFields: IDictionary<IPOSPanelConfiguration> = {
  [posConfigurationGroup.GENERAL]: {
    type: posConfigurationGroup.GENERAL,
    name: 'Campos del POS',
  },
  [posConfigurationGroup.CLIENT]: {
    type: posConfigurationGroup.CLIENT,
    name: 'Datos del cliente',
  },
  [posConfigurationGroup.PAYMENTS]: {
    type: posConfigurationGroup.PAYMENTS,
    name: 'Tipos de pago',
  },
  [posConfigurationGroup.CLOSE]: {
    type: posConfigurationGroup.CLOSE,
    name: 'Tipos de cierre',
  },
  [posConfigurationGroup.INVOICE]: {
    type: posConfigurationGroup.INVOICE,
    name: 'Tipos de facturación',
  },
  [posConfigurationGroup.TABS]: { type: posConfigurationGroup.TABS, name: 'Pestañas' },
  [posConfigurationGroup.ACTIONS]: {
    type: posConfigurationGroup.ACTIONS,
    name: 'Acciones',
  },
}

const posConfigurationParams: IPOSParam[] = [
  {
    id: 'showUserTerminalsOnly',
    name: 'Mostrar solo terminales abiertas por el usuario',
    description:
      'Activa esta opción para filtrar la vista y mostrar únicamente las terminales que han sido abiertas por el usuario en cuestión.',
  },
  {
    id: 'requestGuestCountOnOrderStart',
    name: 'Solicitar número de comensales / participantes al iniciar una orden',
    description:
      'Activa esta opción para que, al iniciar una orden en una terminal libre, se solicite al usuario que indique la cantidad de comensales o participantes. ',
  },
  {
    id: 'approveWithExtraData',
    name: 'Concluir ventas con datos adicionales',
    description:
      'Activa esta opción para poder concluir las ventas con parámetros de despachos de inventario adicionales.',
  },
  {
    id: 'withMultiplePrices',
    name: 'Operar ítems con sus precios configurados',
    description:
      'Activa esta opción para que los ítems se operen con los precios configurados en el modulo de ítems.',
  },
  {
    id: 'discountWithToken',
    name: 'Descuentos con autorización',
    description:
      'Activa esta opción para que los descuentos requieran de una autorización por token para ser aplicados.',
  },
  {
    id: 'approximateTip',
    name: 'Aproximar propina',
    description:
      'Activa esta opción para que el sistema aproxime la propina a un monto redondeado.',
  },
  {
    id: 'viewItemCodes',
    name: 'Visualizar códigos de ítems',
    description:
      'Activa esta opción para que en la app de KOLO se muestren los Códigos/SKU de los ítems.',
  },
  {
    id: 'seeCategoriesFilter',
    name: 'Visualizar filtro de categorías de terminales',
    description:
      'Activa esta opción para que en la app de KOLO se pueda visualizar el filtro de terminales por categorías.',
  },
  {
    id: 'transferTerminalWithToken',
    name: 'Transferencia de terminal con TOKEN',
    description:
      'Activa está opción para solicitar al usuario un token de autorización para transferir una terminal a otra.',
  },
  {
    id: 'enabledDefaultClient',
    name: 'Habilitar ventas a cliente consumidor final',
    description:
      'Activa esta opción para que las ventas se puedan realizar al cliente por defecto "Consumidor Final".',
  },
  {
    id: 'needTokenToUpdateTip',
    name: 'Token para actualizar propina',
    description:
      'Activa esta opción para que se solicite un token de autorización para actualizar la propina en una venta.',
  },
  {
    id: 'printManufactureAutomatically',
    name: 'Impresión automática de comandas',
    description:
      'Activa esta opción para que las comandas se impriman automáticamente al agregar ítems a la orden.',
  },
  {
    id: 'receiveDailyDeletedItemsReport',
    name: 'Reporte diario de ítems eliminados',
    description:
      'Activa esta opción para recibir un reporte diario con los ítems que han sido eliminados de una comanda.',
  },
  {
    id: 'receiveRealtimeDeletedItemsReport',
    name: 'Reporte en tiempo real de ítems eliminados',
    description:
      'Activa esta opción para recibir un reporte en tiempo real cada vez que se elimine un ítem de una comanda.',
  },
  {
    id: 'printTicketDeletedItems',
    name: 'Imprimir ticket de ítems eliminados',
    description:
      'Activa esta opción para que se imprima un ticket cada vez que se elimine un ítem de una comanda.',
  },
  {
    id: 'enabledTakeAway',
    name: 'Habilitar opción para llevar',
    description:
      'Activa esta opción para que en las ventas se pueda seleccionar la opción de "Para llevar".',
  },
  {
    id: 'requiredReasonToRemoveItems',
    name: 'Motivo requerido para eliminar ítems',
    description:
      'Activa esta opción para que se solicite un motivo al usuario cada vez que se elimine un ítem de una comanda.',
  },
]

export {
  posPanelConfigurations,
  posConfigurationGroupFields,
  posPanelConfigurationFields,
  posConfigurationParams,
}
